<template>
  <!-- name: '发货地址编辑' -->
  <div class="addressEditWrap">
    <div class="infoCard">
      <label for="contacts">姓名</label>
      <input
        type="text"
        id="contacts"
        v-model="curObjData.contacts"
        placeholder="请填写您的姓名"
      />
    </div>
    <div class="infoCard">
      <label for="phone">电话</label>
      <input
        type="text"
        id="phone"
        v-model="curObjData.phone"
        placeholder="请填写您的电话"
      />
    </div>
    <div class="infoCard">
      <label for="area">省市区</label>
      <input
        type="text"
        id="area"
        v-model="curObjData.area"
        @click="areaVisible = true"
        placeholder="请选择省市区"
        class="areaClass"
        readonly="readonly"
      />
    </div>
    <div class="infoCard">
      <label for="address">地址</label>
      <textarea
        id="address"
        v-model="curObjData.address"
        placeholder="请输入具体地址"
      />
    </div>
    <div class="setDetault">
      <label>设为默认地址</label>
      <input
        type="checkBox"
        :checked="curObjData.isDefault"
        @change="curObjData.isDefault = !curObjData.isDefault"
      />
    </div>
    <button class="saveBtn" v-if="!$route.query.objData" @click="handleSave()">
      保存
    </button>
    <div class="btnBox" v-else>
      <button @click="showPoint = true" class="deleteBtn">删除</button>
      <button @click="handleSave()" class="saveBtn">保存</button>
    </div>

    <VuePicker
      :data="cityData"
      :layer="3"
      :showToolbar="true"
      @cancel="areaVisible = false"
      @confirm="handleConfirm"
      :visible.sync="areaVisible"
      :defaultIndex="defaultIndex"
    />

    <van-dialog
      v-model="showPoint"
      confirmButtonColor="#00a392"
      :showCancelButton="true"
      confirmButtonText="确认"
      cancelButtonText="取消"
      @confirm="
        handleDelete();
        showPoint = true;
      "
    >
      <p>你确定要删除此地址吗？</p>
    </van-dialog>
  </div>
</template>

<script>
import VuePicker from "vue-pickers";
import CITYDATA from "@/assets/js/cityData.js";
import { myAddressSave, myAddressDelete } from "@/api/userCenter";
export default {
  components: { VuePicker },
  data() {
    return {
      curObjData: {
        contacts: "",
        isDefault: true,
      },
      areaVisible: false,
      cityData: CITYDATA,
      defaultIndex: [],
      defaultArea: [],
      showPoint: false,
    };
  },
  created() {
    this.curObjData = this.$route.query.objData
      ? Object.assign({}, this.$route.query.objData)
      : this.curObjData;
    this.curObjData.isDefault = this.curObjData.isDefault === 1 ? true : false;
    this.defaultArea = [
      this.curObjData.provinceName,
      this.curObjData.cityName,
      this.curObjData.districtName,
    ];
    if (this.curObjData) {
      this.curObjData.area = this.defaultArea.join("");
      let child1 = [];
      this.cityData.map((item) => {
        if (item.label === this.curObjData.provinceName) {
          this.defaultIndex.push(item.sort);
          child1 = item.children;
        }
      });
      let child2 = [];
      child1.map((item) => {
        if (item.label === this.curObjData.cityName) {
          this.defaultIndex.push(item.sort);
          child2 = item.children;
        }
      });
      child2.map((item) => {
        if (item.label === this.curObjData.districtName) {
          this.defaultIndex.push(item.sort);
        }
      });
    }
  },
  methods: {
    async handleMyAddressSave(tempObj) {
      const { code, message } = await myAddressSave(tempObj);
      if (code === 200) {
        this.$toast.success("保存成功");
        this.$router.push({
          path: "/userInfo",
          query: {
            curSelectTab: "发货地址",
          },
        });
      } else {
        this.$toast.fail(message);
      }
    },

    handleConfirm(res) {
      this.areaVisible = false;
      this.curObjData.area = res
        .map((item) => {
          return item.label;
        })
        .join(" ");

      this.curObjData.provinceName = res[0].label;
      this.curObjData.cityName = res[1].label;
      this.curObjData.districtName = res[2].label;
    },
    handleSave() {
      if (
        this.curObjData.contacts &&
        this.curObjData.phone &&
        this.curObjData.provinceName &&
        this.curObjData.address
      ) {
        const regex = /^1[3-9]\d{9}$/;
        if (!regex.test(this.curObjData.phone)) {
          this.$toast.fail("请填写正确的手机号码！");
        } else {
          let tempObj = Object.assign({}, this.curObjData);
          delete tempObj.area;
          tempObj.isDefault = this.curObjData.isDefault ? 1 : 2;
          this.handleMyAddressSave(tempObj);
        }
      } else if (!this.curObjData.contacts) {
        this.$toast.fail("请输入姓名");
      } else if (!this.curObjData.phone) {
        this.$toast.fail("请输入电话号码");
      } else if (!this.curObjData.provinceName) {
        this.$toast.fail("请选择省市区");
      } else if (!this.curObjData.address) {
        this.$toast.fail("请输入详细地址");
      }
    },
    async handleDelete() {
      const { code, message } = await myAddressDelete(this.curObjData.id);
      if (code === 200) {
        this.$toast.success("删除成功");
        this.$router.push({
          path: "/userInfo",
          query: {
            curSelectTab: "发货地址",
          },
        });
      } else {
        this.$toast.fail(message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.addressEditWrap {
  margin-top: 9vw;
  height: calc(100% - 100px);
  width: 100%;
   padding-bottom: 37px;
  overflow: auto;
  background-color: #f5f5f5;
  font-family: PingFangSC, PingFang SC;
  display: flex;
  flex-flow: column;
  align-items: center;
  .infoCard {
    width: 686px;
    background: #ffffff;
    border-radius: 16px;
    margin-bottom: 24px;
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    padding: 24px 32px;
    label {
      margin-bottom: 24px;
      height: 28px;
      font-size: 22px;

      font-weight: 400;
      color: #666666;
    }
    input {
      border: none;
      width: 622px;
      font-size: 32px;
      font-weight: 400;
      color: #333333;
      &.areaClass {
        background-image: url("https://img.bbalt.cn/imgh5/icon_narrow_right.svg");
        background-size: 30px 30px;
        background-repeat: no-repeat;
        padding-right: 30px;
        background-position: center right;
      }
    }
    textarea {
      width: 100%;
      border: none;
    }
    &:first-child {
      margin-top: 47px;
    }
  }
  .setDetault {
    width: 686px;
    height: 116px;
    background: #ffffff;
    border-radius: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 32px;
    margin: 32px 0px;
  }
  .saveBtn {
    margin-top: 40px;
    width: 686px;
    height: 88px;
    background: #fe66a6;
    border-radius: 47px;
    border: none;
    font-size: 32px;
    font-weight: 600;
    color: #ffffff;
  }
  .btnBox {
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
    .deleteBtn {
      width: 320px;
      font-size: 32px;
      font-weight: 600;
      color: #ffffff;
      height: 88px;
      background: #679fd2;
      border-radius: 47px;
      border: none;
      margin-right: 40px;
    }
    .saveBtn {
      width: 320px;
      margin: 0px;
    }
  }
}
.van-dialog p {
  padding: 20px;
  line-height: 40px;
  text-align: center;
}
::v-deep .van-dialog__header {
  color: #000;
}
::v-deep .van-dialog__content {
  display: flex;
  flex-flow: column;
  justify-content: center;
  margin: 30px 0px;
}
</style>
